import { defineMessages } from 'react-intl'

export default defineMessages({
  changeMe: {
    id: 'components.PaymentMethodRender.changeMe',
    defaultMessage: '请修改',
    description: '请修改'
  },
  HowWouldYouLikeToPay:{
    id: 'components.PaymentMethodRender.HowWouldYouLikeToPay',
    defaultMessage: 'How would you like to Pay?',
    description: '请修改'
  }
})
